'use strict';

/**
 * @author Henrik Reinbach Madsen
 * @requires flickity.js https://github.com/metafizzy/flickity
 */

var novicell = novicell || {};


novicell.slideshow = novicell.slideshow || new function () {
    const slideshows = document.querySelectorAll('.js-slideshow');

    this.init = function () {
        if (!slideshows) {
            return;
        }
        for (let i = 0; i < slideshows.length; i++) {
            const slideshowElm = slideshows[i];
            const self = this;
            const flkty = new Flickity(slideshowElm, {
                // options
                cellAlign: 'left',
                cellSelector: '.slideshow-slide',
                contain: true,
                wrapAround: true,
                pageDots: false,
                arrowShape: 'M71.3,100 21.3,50 71.3,0 78.7,7.5 36.2,50 78.7,92.5 z',
                on: {
                    select: function(e) {
                        self.resetVideoIframes(slideshowElm);
                    }
                }
            });

        }
    };

    this.resetVideoIframes = function (slideshowElm) {
        const iframes = slideshowElm.getElementsByTagName('iframe');
        for (var i = 0; i < iframes.length; i++) {
            iframes[i].parentElement.parentElement.classList.remove('embed-media--active');
            iframes[i].remove();
        }
    };
}();
